import { pipefyApi, resaleApi } from 'service/api'

export const sendProposalWizard = async payload => {
  const response = await pipefyApi.post('/fsp/proposal', payload)

  if (!response.ok) {
    const message =
      response.data?.message || 'Erro ao registrar a proposta. Tente novamente.'
    throw new Error(message)
  }

  return response.data
}

export const getSalesChannel = async code => {
  const response = await resaleApi.get(`/sales-channel?codigo-canal=${code}`)

  if (!response.ok) {
    throw new Error('Erro ao buscar canal de vendas. Tente novamente!')
  }

  return response.data
}

export default sendProposalWizard
